import {
  Auth,
  AccessToken,
  SignupRequestModel,
  Message,
  PhoneNumberCodeModel,
  UserIdRequestModel,
} from "../../../domain/model/Auth";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { AuthRepository } from "./AuthRepository";

export class AuthRepositoryImpl implements AuthRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }

  login(auth: Auth): Promise<Response<AccessToken>> {
    return this.apiService.login(auth);
  }
  signup(signupRequestModel: SignupRequestModel): Promise<Response<Message>> {
    return this.apiService.signup(signupRequestModel);
  }
  loginAsGuestPlayer(): Promise<Response<AccessToken>> {
    return this.apiService.loginAsGuestPlayer();
  }
  loginByUID(model: UserIdRequestModel): Promise<Response<AccessToken>> {
    return this.apiService.loginByUID(model);
  }
  forgotPassword(email: string): Promise<Response<Message>> {
    return this.apiService.forgotPassword(email);
  }
  resetPassword(auth: Auth): Promise<Response<Message>> {
    return this.apiService.resetPassword(auth);
  }
  sendVerificationCode(
    model: PhoneNumberCodeModel
  ): Promise<Response<Message>> {
    return this.apiService.sendVerificationCode(model);
  }
  checkVerificationCode(
    model: PhoneNumberCodeModel
  ): Promise<Response<Message>> {
    return this.apiService.checkVerificationCode(model);
  }
}
